import React from 'react';
import { CheckIcon } from 'lucide-react';
import { outcomes } from '../data/content';
import { RichText } from './RichText';
import { SectionHeading } from './SectionHeading';
export function Outcomes() {
  return <section className="px-6 py-12" data-id="element-55" data-mp="1m9ukecfcaq6j">
      <SectionHeading eyebrow="The result" data-id="element-56" data-mp="1m6q80rrq0o4s">
        What will you achieve with the Little Engineer Kit?
      </SectionHeading>

      <ul className="mt-7 space-y-5" data-id="element-57" data-mp="tkf9dmnocxam">
        {outcomes.map((line, index) => <li key={index} className="flex gap-3.5" data-id="element-58" data-mp="tiaxahfmgrz9" data-mpi={index}>
            <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-600" aria-hidden="true" data-id="element-59" data-mp="yk9xjig2f8rz">
              <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} data-id="element-60" data-mp="189jt58a4b9ku" />
            </span>
            <p className="text-[16.5px] leading-[1.65] text-ink-800" data-id="element-61" data-mp="atxhfkao25qb">
              <RichText line={line} data-id="element-62" data-mp="arjnjerq2zkc" />
            </p>
          </li>)}
      </ul>
    </section>;
}